export default __webpack_public_path__ + "static/media/fdf80b5de7aaec5b46298d67b14eed4abd003ef6c6101d8223afb980ef845f8c.50ee54e9.svg";